import { countryCodeToCountryName } from "@/utils/countries.util";
import { CompanyEntryDto } from "@advanced-sales-technologies/backend-client/models/CompanyEntryDto";
import { ColumnDef } from "@tanstack/react-table";
import { TFunction } from "i18next";
import { HiOutlineMapPin } from "react-icons/hi2";

import BaseColumn from "@/components/molecules/table/BaseColumn";
import { searchColumns } from "@/components/organisms/search/searchColumns";

const hqCountryColumn = (t: TFunction): ColumnDef<CompanyEntryDto> =>
  BaseColumn<CompanyEntryDto>({
    accessorFn: (row) =>
      row.office_hq?.address?.country_code && countryCodeToCountryName(row.office_hq.address.country_code),
    id: searchColumns(t).hq_country.id,
    header: () => searchColumns(t).hq_country.name,
    cell: (info) => info.getValue<string>(),
    meta: {
      heading: {
        icon: HiOutlineMapPin,
        className: "!bg-var-warning-50 hover:!bg-var-warning-100 active:!bg-var-warning-200",
      },
      column: {
        className: "bg-var-warning-25",
      },
    },
  });

export default hqCountryColumn;
